/* fb-cart.js — FreshBox premium side cart.
   Opens on click of the header cart icon. Renders line items +
   totals from /cart.js; qty +/- and remove call /cart/change.js. Re-renders on any
   cart change (cart:updated / cart:refresh) so it's always current — even when closed.
   It does NOT auto-open on add (the fly-to-cart lands on the icon; the drawer waits). */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-fb-cd]');
  if (!drawer) return;
  var scrim   = document.querySelector('[data-fb-cd-scrim]');
  var itemsEl = drawer.querySelector('[data-fb-cd-items]');
  var emptyEl = drawer.querySelector('[data-fb-cd-empty]');
  var footEl  = drawer.querySelector('[data-fb-cd-foot]');
  var countEl = drawer.querySelector('[data-fb-cd-count]');
  var subEl   = drawer.querySelector('[data-fb-cd-subtotal]');
  var recsWrap = drawer.querySelector('[data-fb-cd-recs]');
  var recsRail = drawer.querySelector('[data-fb-cd-recs-rail]');
  var emptyRecsWrap  = drawer.querySelector('[data-fb-cd-empty-recs-wrap]');
  var emptyRecsEl    = drawer.querySelector('[data-fb-cd-empty-recs]');
  var emptyRecsTitle = drawer.querySelector('[data-fb-cd-empty-recs-title]');
  var cartBtn  = document.querySelector('.site-header-cart--button');
  // free-shipping meter (slim bar in the footer)
  var fsEl     = drawer.querySelector('[data-fb-cd-fs]');
  var fsTextEl = drawer.querySelector('[data-fb-cd-fs-text]');
  var fsBarEl  = drawer.querySelector('[data-fb-cd-fs-bar]');
  // peek (slim desktop column) refs
  var fullEl       = drawer.querySelector('[data-fb-cd-full]');
  var peekEl       = drawer.querySelector('[data-fb-cd-peek]');
  var peekThumbsEl = drawer.querySelector('[data-fb-cd-peek-thumbs]');
  var peekSubEl    = drawer.querySelector('[data-fb-cd-peek-subtotal]');
  var peekArrow    = document.querySelector('[data-fb-cd-peek-arrow]');
  var peekHandle   = document.querySelector('[data-fb-cd-peek-handle]');
  var mqDesktop    = window.matchMedia('(min-width: 1024px)');

  var lastCart = null;
  var latestKeys = null;       // claves y variantes del último carrito que devolvió el servidor (aunque no se haya pintado).
                               // Copia aparte: lastCart se edita en sitio (optimista) y compartir el objeto la contaminaba.
  var TRASH = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M9.75 2.5A1.75 1.75 0 0 0 8 4.25V5.5H4.75a1.1 1.1 0 1 0 0 2.2h14.5a1.1 1.1 0 1 0 0-2.2H16V4.25a1.75 1.75 0 0 0-1.75-1.75h-4.5zm4.05 3V4.7h-3.6v.8h3.6zM6 9.2h12l-.75 10.2a2.2 2.2 0 0 1-2.2 2.1H8.95a2.2 2.2 0 0 1-2.2-2.1L6 9.2zm3.1 3.1a.9.9 0 0 1 1.8 0v5.6a.9.9 0 0 1-1.8 0v-5.6zm4 0a.9.9 0 0 1 1.8 0v5.6a.9.9 0 0 1-1.8 0v-5.6z"/></svg>';
  var GRACE_MS = 500;          // al llegar a 1, el bote no responde medio segundo (ráfaga de toques en −)
  var UNDO_MS = 6000;          // cuánto dura el "Deshacer" tras quitar una línea
  var undoEl = drawer.querySelector('[data-fb-cd-undo]');
  var undoTextEl = drawer.querySelector('[data-fb-cd-undo-text]');
  var undoBtn = drawer.querySelector('[data-fb-cd-undo-btn]');
  var undoT = null, undoPayload = null;
  var noticeEl = drawer.querySelector('[data-fb-cd-notice]');
  var noticeT = null;
  var pointerInDrawer = false; // while true, page scroll must NOT close the drawer
  var selfMutating = false;    // true while we dispatch our own cart:updated (avoid self re-render)
  var changeSeq = 0;           // guards against out-of-order qty responses
  var ownMuteUntil = 0;        // until this ts the fetch-wrap ignores cart mutations (they're ours)
  var firstPaint = true;       // suppress the open/dock animation on the cart's first appearance
  var SECTION_REC = 'fb-rec-list';
  var recCache = { key: null, html: null }; // memoized rec HTML per (seed + cart contents)

  // Suppress the widen/dock animation on the cart's very first appearance (page load): without
  // this, the panel animates from its 396 base width DOWN to the 144 peek, reading as "widen then
  // collapse". Removed right after the first paint so expand/collapse still animate normally.
  document.documentElement.classList.add('fb-cart-no-anim');

  /* ---- helpers ---- */
  function money(c) { return '$ ' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function sized(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getCart() {
    return window.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function marcaServidor(cart) {
    latestKeys = ((cart && cart.items) || []).map(function (it) { return { key: it.key, vid: String(it.variant_id) }; });
  }
  // Respuesta de /cart/*.js: un 400/422/429 también trae JSON, pero no es un carrito.
  function cartJSON(r) {
    if (r.ok) return r.json();
    return r.json().then(function (e) { throw e; }, function () { throw { status: r.status }; });
  }
  // Aviso al cliente cuando un cambio no se aplicó. Antes el número se revertía en silencio.
  function aviso(err) {
    if (!noticeEl) return;
    var msg = (err && (err.description || err.message)) || '';
    // "Cart Error" y "parámetro lineal no válido" son técnicos: al cliente no le dicen nada.
    if (!msg || /^cart error$/i.test(msg) || err && err.status === 'bad_request') msg = 'No pudimos actualizar tu carrito. Intenta de nuevo.';
    noticeEl.textContent = msg;
    noticeEl.hidden = false;
    if (noticeT) window.clearTimeout(noticeT);
    noticeT = window.setTimeout(function () { noticeEl.hidden = true; }, 5000);
  }


  /* ---- render ---- */
  function itemHTML(it) {
    var img = it.image ? sized(it.image, 160) : '';
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    /* Frecuencia del plan de suscripción, corta: "Entregar cada mes, 5% de
       descuento" → "Suscripción · cada mes". El descuento ya se ve en el precio. */
    var sp = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) || null;
    var plan = '';
    if (sp) {
      plan = String((sp.options && sp.options[0] && sp.options[0].value) || sp.name || '').replace(/^Entregar?\s+/i, '').replace(/,.*$/, '').trim();
      plan = plan ? 'Suscripción · ' + plan.toLowerCase() : '';
    }
    var sale = it.original_line_price > it.final_line_price;
    return '<div class="fb-cd-item" data-key="' + esc(it.key) + '" data-vid="' + esc(it.variant_id) + '">'
      + '<a class="fb-cd-item__media" href="' + esc(it.url) + '" tabindex="-1">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>'
      + '<div class="fb-cd-item__info">'
      +   '<a class="fb-cd-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>'
      +   (variant ? '<span class="fb-cd-item__variant">' + esc(variant) + '</span>' : '')
      +   (plan ? '<span class="fb-cd-item__plan">' + esc(plan) + '</span>' : '')
      +   '<div class="fb-cd-item__row">'
      +     '<div class="fb-cd-qty">'
      +       '<button type="button" data-cd-dec' + (it.quantity <= 1 ? ' class="fb-cd-dec--last" aria-label="Quitar producto">' + TRASH : ' aria-label="Quitar uno">−') + '</button>'
      +       '<span class="fb-cd-qty__n">' + it.quantity + '</span>'
      +       '<button type="button" data-cd-inc aria-label="Agregar uno">+</button>'
      +     '</div>'
      +     '<div class="fb-cd-item__price">'
      +       '<span class="fb-cd-item__now' + (sale ? ' is-sale' : '') + '">' + money(it.final_line_price) + '</span>'
      +       (sale ? '<span class="fb-cd-item__was">' + money(it.original_line_price) + '</span>' : '')
      +     '</div>'
      +   '</div>'
      + '</div>'
      + '<button class="fb-cd-item__remove" data-cd-remove aria-label="Quitar producto">&times;</button>'
      + '</div>';
  }
  /* Productos que entraron juntos desde una caja (página de Cajas o Mi cuenta) traen la
     propiedad _caja_ref: se pintan dentro de un bloque con la foto de la caja, su nombre, el
     total y "Quitar caja". La lista va abierta y se puede plegar; lo plegado se recuerda en la
     sesión porque el carrito se vuelve a pintar a cada cambio.
     Los renglones siguen siendo .fb-cd-item, así que +/−, deshacer y lo optimista no cambian. */
  var BOX_ASSETS = (function () {
    var sc = document.currentScript || document.querySelector('script[src*="/fb-cart.js"]');
    return sc && sc.src ? sc.src.replace(/fb-cart\.js.*$/, '') : '';
  })();
  var boxCerradas = {};
  try { boxCerradas = JSON.parse(sessionStorage.getItem('fb_cd_box_cerradas') || '{}') || {}; } catch (e) {}
  function guardaCerradas() { try { sessionStorage.setItem('fb_cd_box_cerradas', JSON.stringify(boxCerradas)); } catch (e) {} }
  function boxMeta(n) { return n + ' producto' + (n > 1 ? 's' : ''); }
  function itemsHTML(items) {
    var orden = [], grupos = {};
    items.forEach(function (it) {
      var ref = it.properties && it.properties._caja_ref;
      if (!ref) { orden.push({ it: it }); return; }
      if (!grupos[ref]) { grupos[ref] = { ref: ref, id: it.properties._caja || '', nombre: it.properties.Caja || 'Caja', items: [] }; orden.push({ g: grupos[ref] }); }
      grupos[ref].items.push(it);
    });
    return orden.map(function (x) {
      if (x.it) return itemHTML(x.it);
      var g = x.g, tot = g.items.reduce(function (s, it) { return s + it.final_line_price; }, 0), cerrada = !!boxCerradas[g.ref];
      var foto = g.id && BOX_ASSETS ? BOX_ASSETS + 'caja-foto-' + encodeURIComponent(g.id) + '.webp' : (g.items[0] && g.items[0].image) || '';
      return '<div class="fb-cd-box' + (cerrada ? ' is-closed' : '') + '" data-box-ref="' + esc(g.ref) + '">'
        + '<div class="fb-cd-box__head">'
        +   '<span class="fb-cd-box__media">' + (foto ? '<img src="' + esc(foto) + '" alt="" loading="lazy" width="72" height="72" onerror="this.parentNode.classList.add(\'is-empty\');this.remove()">' : '') + '</span>'
        +   '<span class="fb-cd-box__info"><span class="fb-cd-box__k">Caja</span><span class="fb-cd-box__n">' + esc(g.nombre) + '</span>'
        +     '<span class="fb-cd-box__sub"><span class="fb-cd-box__meta">' + boxMeta(g.items.length) + '</span><button type="button" class="fb-cd-box__rm" data-cd-box-remove>Quitar caja</button></span></span>'
        +   '<span class="fb-cd-box__side"><span class="fb-cd-box__tot">' + money(tot) + '</span>'
        +     '<button type="button" class="fb-cd-box__tg" data-cd-box-toggle aria-expanded="' + (cerrada ? 'false' : 'true') + '">'
        +       '<span data-cd-box-tg-txt>' + (cerrada ? 'Ver productos' : 'Ocultar') + '</span>'
        +       '<svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true"><path d="M2.5 4.5 6 8l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button></span>'
        + '</div>'
        + '<div class="fb-cd-box__items"' + (cerrada ? ' hidden' : '') + '>' + g.items.map(itemHTML).join('') + '</div></div>';
    }).join('');
  }
  /* Tras un cambio optimista o del servidor: cada bloque de caja recalcula su total y
     cuántos productos le quedan; si ya no le queda ninguno, desaparece. */
  function syncBoxes() {
    if (!lastCart || !lastCart.items) return;
    Array.prototype.forEach.call(itemsEl.querySelectorAll('.fb-cd-box'), function (box) {
      var rows = box.querySelectorAll('.fb-cd-item');
      if (!rows.length) { delete boxCerradas[box.getAttribute('data-box-ref')]; guardaCerradas(); box.parentNode.removeChild(box); return; }
      var tot = 0;
      Array.prototype.forEach.call(rows, function (r) { var it = itemByKey(r.getAttribute('data-key')); if (it) tot += it.final_line_price; });
      var meta = box.querySelector('.fb-cd-box__meta'), totEl = box.querySelector('.fb-cd-box__tot');
      if (meta) meta.textContent = boxMeta(rows.length);
      if (totEl) totEl.textContent = money(tot);
    });
  }
  function toggleBox(box) {
    var ref = box.getAttribute('data-box-ref'), cerrar = !box.classList.contains('is-closed');
    box.classList.toggle('is-closed', cerrar);
    var list = box.querySelector('.fb-cd-box__items'), tg = box.querySelector('[data-cd-box-toggle]'), txt = box.querySelector('[data-cd-box-tg-txt]');
    if (list) list.hidden = cerrar;
    if (tg) tg.setAttribute('aria-expanded', cerrar ? 'false' : 'true');
    if (txt) txt.textContent = cerrar ? 'Ver productos' : 'Ocultar';
    if (cerrar) boxCerradas[ref] = 1; else delete boxCerradas[ref];
    guardaCerradas();
  }
  function render(cart) {
    lastCart = cart;
    var n = (cart && cart.item_count) || 0;
    if (countEl) countEl.textContent = n;
    if (n > 0) {
      itemsEl.innerHTML = itemsHTML(cart.items.slice().reverse()); // newest line first (top); las de una caja, juntas
      itemsEl.hidden = false;
      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.hidden = false;
      if (subEl) subEl.textContent = money(cart.total_price);
    } else {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      renderEmptyRecs();
    }
    renderRecs(cart);
    renderPeek(cart);
    renderFS(cart);
    syncChrome();
    if (firstPaint) {
      firstPaint = false;
      // let the peek settle at its final width, THEN re-enable transitions for future open/close
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { document.documentElement.classList.remove('fb-cart-no-anim'); });
      });
    }
  }

  /* ---- recommendations rail (server-rendered cards via the Recommendations Section
     Rendering API, so Revie review stars come through). Falls back complementary → related. ---- */
  function fetchRecHTML(seedId, intent) {
    return window.fetch('/recommendations/products?section_id=' + SECTION_REC + '&product_id=' + seedId + '&intent=' + intent + '&limit=10', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { var d = new DOMParser().parseFromString(html, 'text/html'); var box = d.querySelector('[data-fb-rec-cards]'); return box ? box.innerHTML : ''; })
      .catch(function () { return ''; });
  }
  // Cache key includes the cart's product set: recs are deduped against the cart server-side,
  // so when the cart changes (e.g. you just added a rec) the cached HTML is stale and must refetch.
  function cartSig() {
    if (!lastCart || !lastCart.items) return '';
    return lastCart.items.map(function (it) { return it.product_id; }).sort().join(',');
  }
  function ensureRecHTML(seedId) {
    var key = seedId + '#' + cartSig();
    if (recCache.key === key) return Promise.resolve(recCache.html);
    return fetchRecHTML(seedId, 'complementary').then(function (html) {
      if (html && /fb-rec-card/.test(html)) return html;   // curated "frequently bought together"
      return fetchRecHTML(seedId, 'related');               // fallback to algorithmic related
    }).then(function (html) { recCache = { key: key, html: html || '' }; return recCache.html; });
  }
  function capCards(container, max) {
    var cards = container.querySelectorAll('.fb-rec-card');
    for (var i = max; i < cards.length; i++) cards[i].parentNode.removeChild(cards[i]);
  }
  var recsSeq = 0; // invalidates in-flight rec fetches when the cart state moves on
  // Las recomendaciones (y sus fotos) solo se piden cuando el cajón se ha abierto: con el cajón
  // cerrado nadie las ve y cada carga de página gastaba una petición a /recommendations más
  // 6-8 imágenes (133 KB en el carrito vacío). `recsPendientes` marca que hay que pintarlas
  // al abrir. En escritorio la columna angosta cuenta como cerrada: no muestra recomendaciones.
  var cajonAbiertoAlgunaVez = false, recsPendientes = false;
  function renderRecs(cart) {
    if (!recsWrap || !recsRail) return;
    if (!cajonAbiertoAlgunaVez) { recsPendientes = true; return; }
    var items = (cart && cart.items) || [];
    var seq = ++recsSeq;
    if (!items.length) { recsWrap.hidden = true; return; }
    var seedId = items[items.length - 1].product_id; // most recently added line
    ensureRecHTML(seedId).then(function (html) {
      // a newer render superseded this one (e.g. the cart emptied while we fetched) —
      // painting now would resurrect the rail over the empty state
      if (seq !== recsSeq) return;
      if (!html || !/fb-rec-card/.test(html)) { recsWrap.hidden = true; return; }
      recsRail.innerHTML = html;
      capCards(recsRail, 8); // side cart: at most 8
      if (!recsRail.querySelector('.fb-rec-card')) { recsWrap.hidden = true; return; }
      recsRail.scrollLeft = 0;
      recsWrap.hidden = false;
    });
  }

  /* ---- peek column (slim desktop rail): total + count + a full-width image card per item.
     Reads the same cart as the full drawer, so the two stay in lockstep. ---- */
  function renderPeek(cart) {
    if (!peekEl) return;
    var items = (cart && cart.items) || [];
    if (peekSubEl) peekSubEl.textContent = money((cart && cart.total_price) || 0);
    if (peekThumbsEl) {
      var rev = items.slice().reverse(); // newest on top, mirroring the full list
      var html = '';
      for (var i = 0; i < rev.length; i++) {
        var it = rev[i];
        var img = it.image ? sized(it.image, 240) : '';
        var sale = it.original_line_price > it.final_line_price;
        html += '<div class="fb-cd__peek-item">'
          + '<span class="fb-cd__peek-thumb">'
          +   (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '')
          +   (it.quantity > 1 ? '<span class="fb-cd__peek-qty">×' + it.quantity + '</span>' : '')
          + '</span>'
          + '<span class="fb-cd__peek-item-name">' + esc(it.product_title) + '</span>'
          + '<span class="fb-cd__peek-item-price' + (sale ? ' is-sale' : '') + '">' + money(it.final_line_price) + '</span>'
          + '</div>';
      }
      peekThumbsEl.innerHTML = html;
    }
  }

  /* ---- empty-cart recommendations: server-rendered best sellers (in the snippet);
     if the customer has a last purchase, swap in recs seeded from it. ---- */
  function renderEmptyRecs() {
    if (!emptyRecsWrap || !emptyRecsEl) return;
    if (!cajonAbiertoAlgunaVez) { recsPendientes = true; return; } // sigue con `hidden`: sus fotos no se bajan
    var lp = drawer.getAttribute('data-fb-cd-last-purchase');
    if (lp) {
      ensureRecHTML(lp).then(function (html) {
        if (html && /fb-rec-card/.test(html)) {
          emptyRecsEl.innerHTML = html;
          capCards(emptyRecsEl, 6);
          if (emptyRecsTitle) emptyRecsTitle.textContent = 'Basado en tu última compra';
        }
        emptyRecsWrap.hidden = !emptyRecsEl.querySelector('.fb-rec-card');
      });
    } else {
      emptyRecsWrap.hidden = !emptyRecsEl.querySelector('.fb-rec-card');
    }
  }

  /* ---- state machine: hidden (empty) · peek (desktop + items) · open (full) ----
     DESKTOP: the cart is a docked column, never an overlay. It rests as the slim peek
     whenever the cart has items and widens to the full drawer when the user clicks the
     expand button (or the header cart icon). No hover, no scrim — instead the page body
     reserves space (the .fb-cart-dock classes on <html>) so the site narrows beside it.
     MOBILE (<1024px): unchanged — the drawer slides in over the page on click, with scrim. ---- */
  function isOpen() { return drawer.classList.contains('is-open'); }
  function isPeek() { return drawer.classList.contains('is-peek'); }
  /* Páginas que renuncian a la columna angosta — ver snippets/fb-sin-peek.liquid.
     Se apaga desde `desktop()` a propósito: es el único lugar del que cuelgan el
     peek, el dock, la flecha y el morph, así que apagarlo ahí las apaga todas y
     el carrito queda con el comportamiento de teléfono (abre completo al picarle
     el ícono, sobre la página). Un `if` por cada una habría dejado combinaciones
     a medias. */
  var sinPeek = document.documentElement.hasAttribute('data-fb-sin-peek');
  function desktop() { return mqDesktop.matches && !sinPeek; }
  function hasItems() { return !!(lastCart && lastCart.item_count > 0); }

  function showScrim() { if (scrim) { scrim.hidden = false; void scrim.offsetWidth; scrim.classList.add('is-open'); } }
  function hideScrim() { if (scrim) { scrim.classList.remove('is-open'); window.setTimeout(function () { if (!drawer.classList.contains('is-open')) scrim.hidden = true; }, 440); } }

  // Reserve page width on desktop so the cart docks beside the content instead of over it.
  function applyDock() {
    var root = document.documentElement;
    if (desktop() && (isPeek() || isOpen())) {
      root.classList.add('fb-cart-dock');
      root.classList.toggle('fb-cart-dock--wide', isOpen());
    } else {
      root.classList.remove('fb-cart-dock', 'fb-cart-dock--wide');
    }
    positionArrow();
  }
  // Vertically align the peek's little tail with the header cart icon so it points at it.
  function positionArrow() {
    if (!peekArrow || !cartBtn) return;
    if (desktop() && isPeek() && !isOpen()) {
      var r = cartBtn.getBoundingClientRect();
      if (r.height) peekArrow.style.top = (r.top + r.height / 2 - 9) + 'px';
    }
  }
  window.addEventListener('resize', positionArrow);

  // Resting chrome after any render: peek on desktop w/ items, otherwise hidden.
  // Never disturbs an open drawer (only re-syncs the dock width for it).
  function syncChrome() {
    if (!isOpen()) {
      if (desktop() && hasItems()) { drawer.classList.add('is-peek'); drawer.setAttribute('aria-hidden', 'true'); }
      else drawer.classList.remove('is-peek');
    }
    applyDock();
  }

  /* ---- shared-element morph: when the cart widens/narrows on desktop, fly each item photo
     from its slim-peek slot to its full-drawer slot (and back), so the two layouts read as one
     cart reshaping rather than a cross-fade between two unrelated panels. Both layers are always
     laid out (only their opacity toggles), so from/to rects are measurable at any moment. The
     items are newest-first in BOTH lists, so index i maps the same product across them. ---- */
  var fullScroll = drawer.querySelector('[data-fb-cd-scroll]');
  // fly one photo clone from its `from` slot to its `to` slot, hiding the destination photo
  // until the clone lands (so there's no double image). Skips if either end is off-screen.
  function flyClone(from, to) {
    if (!from || !to) return;
    var fr = from.getBoundingClientRect();
    var tr = to.getBoundingClientRect();
    if (!fr.width || !tr.width) return;
    if (fr.bottom < -8 || fr.top > window.innerHeight + 8) return; // source scrolled out of view
    if (tr.bottom < -8 || tr.top > window.innerHeight + 8) return; // destination off-screen → nothing to connect to
    var im = from.querySelector('img') || to.querySelector('img');
    var src = im ? (im.currentSrc || im.src) : '';
    if (!src) return;
    to.style.opacity = '0';
    var clone = document.createElement('img');
    clone.className = 'fb-cd-morph';
    clone.src = src;
    clone.style.left = fr.left + 'px';
    clone.style.top = fr.top + 'px';
    clone.style.width = fr.width + 'px';
    clone.style.height = fr.height + 'px';
    document.body.appendChild(clone);
    var tx = tr.left - fr.left, ty = tr.top - fr.top;
    var sx = tr.width / fr.width, sy = tr.height / fr.height;
    void clone.offsetWidth; // commit the start rect before transitioning
    clone.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sx + ',' + sy + ')';
    var done = false;
    function finish() { if (done) return; done = true; to.style.opacity = ''; if (clone.parentNode) clone.parentNode.removeChild(clone); }
    clone.addEventListener('transitionend', function (e) { if (e.propertyName === 'transform') finish(); });
    window.setTimeout(finish, 680);
  }
  // index of the item sitting closest to the scroller's top edge (the one the shopper sees first)
  function topItemIndex(scroller, items) {
    if (!scroller || !items.length) return 0;
    var srect = scroller.getBoundingClientRect();
    var best = 0, bestDelta = Infinity;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.bottom <= srect.top + 1) continue; // fully scrolled above the fold
      var delta = Math.abs(r.top - srect.top);
      if (delta < bestDelta) { bestDelta = delta; best = i; }
    }
    return best;
  }
  // scroll `scroller` so items[index] sits at its top edge — so the incoming layout lines up with
  // the one we're leaving and the morphing photos start/end where the eye already is.
  function alignScroll(scroller, items, index) {
    if (!scroller || index < 0 || index >= items.length) return;
    var srect = scroller.getBoundingClientRect();
    var r = items[index].getBoundingClientRect();
    scroller.scrollTop += (r.top - srect.top);
  }
  // expand: peek photos → full rows. collapse: full rows → peek photos. Both lists are
  // newest-first, so index i is the same product in both.
  function runMorph(expand) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !desktop()) return;
    var peekItems = peekThumbsEl ? peekThumbsEl.querySelectorAll('.fb-cd__peek-item') : [];
    var fullItems = itemsEl.querySelectorAll('.fb-cd-item');
    var n = Math.min(peekItems.length, fullItems.length);
    if (!n) return;
    var srcScroller = expand ? peekThumbsEl : fullScroll;
    var dstScroller = expand ? fullScroll : peekThumbsEl;
    var srcItems = expand ? peekItems : fullItems;
    var dstItems = expand ? fullItems : peekItems;
    alignScroll(dstScroller, dstItems, topItemIndex(srcScroller, srcItems)); // sync incoming scroll BEFORE measuring
    for (var i = 0; i < n; i++) {
      var from = expand ? peekItems[i].querySelector('.fb-cd__peek-thumb') : fullItems[i].querySelector('.fb-cd-item__media');
      var to   = expand ? fullItems[i].querySelector('.fb-cd-item__media') : peekItems[i].querySelector('.fb-cd__peek-thumb');
      flyClone(from, to);
    }
  }

  function openFull() {
    var wasPeek = isPeek();
    if (!cajonAbiertoAlgunaVez) {
      cajonAbiertoAlgunaVez = true;
      if (recsPendientes) { recsPendientes = false; if (hasItems()) renderRecs(lastCart); else renderEmptyRecs(); }
    }
    drawer.classList.remove('is-peek');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    // Expanding overlays the page (the dock stays at the peek width), so dim the content
    // behind it on every viewport. Clicking the scrim collapses back to the peek.
    showScrim();
    document.documentElement.classList.remove('fb-cart-peek-hover'); // drop the hover handle
    // En móvil el cajón es una capa sobre la página: si la página sigue pudiendo
    // desplazarse, un dedo sobre el pie o el encabezado la mueve y el cierre-por-scroll
    // de abajo tumba el cajón. Se congela la página como hace el menú (fb-chrome.js).
    if (!desktop()) document.documentElement.classList.add('fb-cd-lock');
    applyDock();
    if (wasPeek) runMorph(true); // peek photos slide into the full rows
    if (recsRail) window.requestAnimationFrame(function () { recsRail.scrollLeft = 0; });
  }
  function close() {
    var wasOpen = isOpen();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fb-cd-lock');
    hideScrim();
    if (desktop() && hasItems()) drawer.classList.add('is-peek'); // settle back to the peek
    else drawer.classList.remove('is-peek');
    applyDock();
    if (wasOpen && desktop() && hasItems()) runMorph(false); // full rows fold back into the peek
  }

  // Header cart icon → toggle the full drawer. Holds new-tab modifiers.
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let new-tab through
      e.preventDefault();
      isOpen() ? close() : openFull();
    });
  }
  // Expand affordances. The whole slim peek column is clickable to widen — except the
  // "Ver carrito" link inside it, which navigates to the cart page. A tall handle juts out
  // of the peek's left edge on hover (CSS) and is the explicit visual cue; it widens too.
  if (peekEl) {
    peekEl.addEventListener('click', function (e) {
      if (!isPeek() || isOpen()) return;
      if (e.target.closest && e.target.closest('a, button')) return; // let links/buttons act
      openFull();
    });
  }
  if (peekHandle) peekHandle.addEventListener('click', function (e) { e.preventDefault(); openFull(); });

  // While the pointer is over the peek (or its handle), reveal the handle. Track relatedTarget
  // so moving between the column and the handle doesn't flicker it away. The same enter/leave
  // also drives pointerInDrawer (mobile page-scroll must not dismiss while interacting).
  function showPeekHandle() {
    if (desktop() && isPeek() && !isOpen()) document.documentElement.classList.add('fb-cart-peek-hover');
  }
  function hidePeekHandle(e) {
    var to = e && e.relatedTarget;
    if (to && ((drawer.contains && drawer.contains(to)) || (peekHandle && peekHandle.contains && peekHandle.contains(to)))) return;
    document.documentElement.classList.remove('fb-cart-peek-hover');
  }
  drawer.addEventListener('mouseenter', function () { pointerInDrawer = true; showPeekHandle(); });
  drawer.addEventListener('mouseleave', function (e) { pointerInDrawer = false; hidePeekHandle(e); });
  // En touch no hay mouseenter antes del primer toque: un dedo dentro del cajón también cuenta.
  drawer.addEventListener('touchstart', function () { pointerInDrawer = true; }, { passive: true });
  ['touchend', 'touchcancel'].forEach(function (ev) {
    drawer.addEventListener(ev, function () { window.setTimeout(function () { pointerInDrawer = false; }, 400); }, { passive: true });
  });
  if (peekHandle) {
    peekHandle.addEventListener('mouseenter', showPeekHandle);
    peekHandle.addEventListener('mouseleave', hidePeekHandle);
  }

  drawer.querySelectorAll('[data-fb-cd-close]').forEach(function (b) { b.addEventListener('click', close); });
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  // MOBILE only: page scroll dismisses the overlay drawer. On desktop the cart is docked
  // (part of the layout), so scrolling must never collapse it.
  window.addEventListener('scroll', function () { if (isOpen() && !desktop() && !pointerInDrawer) close(); }, { passive: true });
  // Re-evaluate peek/dock when crossing the desktop breakpoint (resize / devtools).
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', function () {
    if (isOpen() && !desktop()) showScrim(); // an open desktop dock becomes a mobile overlay
    document.documentElement.classList.toggle('fb-cd-lock', isOpen() && !desktop());
    syncChrome();
  });

  /* ---- qty + remove ---- */
  function qtyFor(key) {
    if (!lastCart || !lastCart.items) return 0;
    for (var i = 0; i < lastCart.items.length; i++) if (lastCart.items[i].key === key) return lastCart.items[i].quantity;
    return 0;
  }
  function rowFor(key) {
    var rows = itemsEl.querySelectorAll('.fb-cd-item');
    for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-key') === key) return rows[i];
    return null;
  }
  // El − nunca se deshabilita: a 1 pieza se vuelve un bote de basura. Un toque quita la línea
  // y aparece "Deshacer"; el cambio de forma frena el dedo, y además hay medio segundo de gracia.
  function setDecState(dec, qty) {
    if (!dec) return;
    var last = qty <= 1, was = dec.classList.contains('fb-cd-dec--last');
    dec.disabled = false;
    dec.classList.toggle('fb-cd-dec--last', last);
    dec.setAttribute('aria-label', last ? 'Quitar producto' : 'Quitar uno');
    if (last !== was) dec.innerHTML = last ? TRASH : '−';
    if (last && !was) dec.setAttribute('data-last-at', String(Date.now()));
  }
  function itemByKey(key) {
    if (!lastCart || !lastCart.items) return null;
    for (var i = 0; i < lastCart.items.length; i++) if (lastCart.items[i].key === key) return lastCart.items[i];
    return null;
  }
  // Quitar una línea (bote o X): se guarda lo necesario para volver a agregarla igual.
  function quitarLinea(row) {
    var key = row.getAttribute('data-key'), vid = row.getAttribute('data-vid');
    var it = itemByKey(key);
    undoPayload = it ? {
      id: it.variant_id, quantity: it.quantity,
      properties: (it.properties && Object.keys(it.properties).length) ? it.properties : undefined,
      selling_plan: (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) ? it.selling_plan_allocation.selling_plan.id : undefined
    } : null;
    change(key, 0, vid);
    mostrarDeshacer(it ? it.product_title : '');
  }
  function mostrarDeshacer(title) {
    if (!undoEl) return;
    if (undoTextEl) undoTextEl.textContent = title ? 'Se quitó ' + title + '.' : 'Producto quitado.';
    undoEl.hidden = false;
    if (undoT) window.clearTimeout(undoT);
    undoT = window.setTimeout(ocultarDeshacer, UNDO_MS);
  }
  function ocultarDeshacer() {
    if (undoT) { window.clearTimeout(undoT); undoT = null; }
    if (undoEl) undoEl.hidden = true;
    undoPayload = null;
  }
  if (undoBtn) undoBtn.addEventListener('click', function () {
    var p = undoPayload; if (!p) return;
    ocultarDeshacer();
    undoBtn.disabled = true;
    cartQueue = cartQueue.then(function () {
      ownMuteUntil = Date.now() + 1500;
      return window.fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin', body: JSON.stringify(p)
      }).then(cartJSON).then(function () { return refresh(); }).catch(function (err) { aviso(err); return refresh(); });
    }).catch(function () {}).then(function () { undoBtn.disabled = false; });
  });
  function recomputeTotals(cart) {
    var count = 0, total = 0;
    cart.items.forEach(function (it) { count += it.quantity; total += it.final_line_price; });
    cart.item_count = count; cart.total_price = total;
    cart.items_subtotal_price = total; // optimistic approximation; reconcile() restores the server value
  }
  // Free-shipping meter: "Te faltan $X para envío gratis" + progress bar. Threshold comes
  // from the theme setting via data-fs-min (in cents). Uses items_subtotal_price (pre-discount,
  // like the cart page) with total_price as optimistic fallback.
  function renderFS(cart) {
    if (window.FBMeters) window.FBMeters.render(cart); // envío gratis + Promo NFL (fb-meters.js)
    if (!fsEl) return;
    var min = parseInt(fsEl.getAttribute('data-fs-min'), 10) || 0;
    var n = (cart && cart.item_count) || 0;
    if (!min || !n) { fsEl.hidden = true; return; }
    var sub = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0;
    var rem = min - sub;
    var pct = Math.max(0, Math.min(100, Math.round(sub * 100 / min)));
    if (fsBarEl) fsBarEl.style.width = pct + '%';
    fsEl.classList.toggle('is-complete', rem <= 0);
    if (fsTextEl) fsTextEl.innerHTML = rem > 0
      ? 'Te faltan <strong>' + money(rem) + '</strong> para <strong>envío gratis</strong>'
      : '¡Tienes <strong>envío gratis</strong>!';
    fsEl.hidden = false;
  }

  function paintTotals(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    if (subEl) subEl.textContent = money(cart.total_price);
    renderPeek(cart); // keep the slim peek in lockstep with optimistic qty/remove/add updates
    renderFS(cart);
  }
  // Optimistic: update lastCart + the DOM immediately, before the network responds.
  function applyOptimistic(key, newQty) {
    if (!lastCart || !lastCart.items) return;
    var item = null;
    for (var i = 0; i < lastCart.items.length; i++) { if (lastCart.items[i].key === key) { item = lastCart.items[i]; break; } }
    if (!item) return;
    var row = rowFor(key);
    if (newQty <= 0) {
      lastCart.items = lastCart.items.filter(function (it) { return it.key !== key; });
      recomputeTotals(lastCart);
      if (!lastCart.items.length) { render(lastCart); return; } // empty state + footer hidden
      if (row) row.parentNode.removeChild(row);
      syncBoxes();
      paintTotals(lastCart);
      renderRecs(lastCart); // membership changed → refresh recs/dedupe
      return;
    }
    item.quantity = newQty;
    item.final_line_price = item.final_price * newQty;
    item.original_line_price = item.original_price * newQty;
    recomputeTotals(lastCart);
    if (row) {
      var n = row.querySelector('.fb-cd-qty__n'); if (n) n.textContent = newQty;
      var now = row.querySelector('.fb-cd-item__now'); if (now) now.textContent = money(item.final_line_price);
      var was = row.querySelector('.fb-cd-item__was'); if (was) was.textContent = money(item.original_line_price);
      var dec = row.querySelector('[data-cd-dec]'); setDecState(dec, newQty);
    }
    syncBoxes();
    paintTotals(lastCart);
  }
  // Reconcile the optimistic state with the server's authoritative cart (discounts, rounding,
  // merged lines). Updates text in place to avoid a flicker; full re-render only on mismatch.
  function reconcile(serverCart) {
    lastCart = serverCart;
    marcaServidor(serverCart);
    paintTotals(serverCart);
    var rows = itemsEl.querySelectorAll('.fb-cd-item');
    var n = serverCart.items.length;
    if (n !== rows.length) { render(serverCart); return; }
    // Shopify recalcula la clave de la línea (variant:hash) cada vez que cambia el monto
    // de descuento asignado — con "Descuentos por volumen" pasa al cruzar 4 piezas. Buscar
    // la fila por la clave nueva fallaba, la fila se quedaba con la vieja y el − moría.
    // Las filas van en el mismo orden que el carrito (invertido): se emparejan por posición,
    // se confirma la variante y se reescribe la clave.
    for (var i = 0; i < n; i++) {
      var it = serverCart.items[i];
      var row = rows[n - 1 - i];
      if (row.getAttribute('data-vid') && row.getAttribute('data-vid') !== String(it.variant_id)) { render(serverCart); return; }
      if (row.getAttribute('data-key') !== it.key) row.setAttribute('data-key', it.key);
      var q = row.querySelector('.fb-cd-qty__n'); if (q) q.textContent = it.quantity;
      var now = row.querySelector('.fb-cd-item__now'); if (now) now.textContent = money(it.final_line_price);
      var was = row.querySelector('.fb-cd-item__was'); if (was) was.textContent = money(it.original_line_price);
      var dec = row.querySelector('[data-cd-dec]'); setDecState(dec, it.quantity);
    }
    syncBoxes();
  }
  // Clave vigente de una línea al momento de mandar la petición: la capturada al tocar,
  // o, si el servidor ya la recalculó, la de la misma variante en el último carrito recibido.
  function claveActual(key, vid) {
    // Solo cuenta lo que dijo el servidor: lastCart es la copia optimista y conserva la
    // clave vieja mientras hay cambios en vuelo, así que consultarla devolvía claves vencidas.
    var lista = latestKeys;
    if (!lista) { if (!lastCart || !lastCart.items) return key; lista = lastCart.items.map(function (it) { return { key: it.key, vid: String(it.variant_id) }; }); }
    for (var i = 0; i < lista.length; i++) if (lista[i].key === key) return key;
    if (!vid) return null;
    var cands = lista.filter(function (x) { return x.vid === String(vid); });
    return cands.length ? cands[0].key : null;
  }
  var cartQueue = Promise.resolve(); // serializes cart writes so they apply in fire order
  function change(key, qty, vid) {
    if (qty < 0) qty = 0;
    applyOptimistic(key, qty);            // instant UI — no waiting, no dimming
    var myseq = ++changeSeq;
    // Serialize the network mutations. Concurrent /cart/change.js calls come back
    // out of order, and with a "last response wins" guard the final paint could be a
    // stale intermediate cart that still holds a just-removed line — so quitting several
    // items fast left some behind (and a refresh showed the server never lost them).
    // A queue forces each change to finish before the next fires, so the last response
    // is the true end state and reconcile() can't resurrect a removed line.
    cartQueue = cartQueue.then(function () {
      var id = claveActual(key, vid);
      if (!id) { if (myseq === changeSeq) refresh(); return; } // la línea ya no existe: repintar del servidor
      ownMuteUntil = Date.now() + 1500; // our own write — let the fetch-wrap skip its external refresh
      return window.fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin', body: JSON.stringify({ id: id, quantity: qty })
      })
        .then(cartJSON)
        .then(function (serverCart) {
          marcaServidor(serverCart);        // aunque no se pinte, es la fuente de claves vigentes
          if (myseq !== changeSeq) return;  // a newer change is still queued — let it paint the final state
          reconcile(serverCart);
          selfMutating = true;              // notify header bubble + cart page, but not our own listener
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: serverCart } }));
          selfMutating = false;
        })
        .catch(function (err) { aviso(err); if (myseq === changeSeq) refresh(); }); // revert from server on error
    }).catch(function () {}); // keep the queue alive even if a step rejects
  }
  itemsEl.addEventListener('click', function (e) {
    var boxRm = e.target.closest ? e.target.closest('[data-cd-box-remove]') : null;
    if (boxRm) {
      var box = boxRm.closest('.fb-cd-box');
      if (box) Array.prototype.forEach.call(box.querySelectorAll('.fb-cd-item'), function (r) { change(r.getAttribute('data-key'), 0, r.getAttribute('data-vid')); });
      return;
    }
    var boxHead = e.target.closest ? e.target.closest('.fb-cd-box__head') : null;
    if (boxHead) { toggleBox(boxHead.parentNode); return; }
    var row = e.target.closest ? e.target.closest('.fb-cd-item') : null;
    if (!row) return;
    var key = row.getAttribute('data-key'), vid = row.getAttribute('data-vid');
    if (e.target.closest('[data-cd-inc]')) change(key, qtyFor(key) + 1, vid);
    else if (e.target.closest('[data-cd-dec]')) {
      var q = qtyFor(key);
      if (q > 1) { change(key, q - 1, vid); return; }
      var dec = e.target.closest('[data-cd-dec]'), at = parseInt(dec.getAttribute('data-last-at'), 10) || 0;
      if (Date.now() - at < GRACE_MS) return; // acaba de llegar a 1: este toque venía en la ráfaga
      quitarLinea(row);
    }
    else if (e.target.closest('[data-cd-remove]')) quitarLinea(row);
  });

  /* ---- add a recommended product. The drawer overlays the header cart icon, so flying the
     thumbnail to that (hidden) icon would read as "nothing happened." Instead, for the
     in-drawer rail we fly the photo to where the NEW LINE will appear (the top of the items
     list) and grow that row in with a controlled height/opacity transition — the thumbnail
     lands exactly where its real row materializes. The rec card itself collapses + the rail
     slides left (FLIP). The empty-cart rail flips the whole view to the items state, so it
     keeps the simpler header fly + full refresh. ---- */

  // FLIP slide: drop `card` and animate the surviving rail cards from their old positions
  // into their new ones, so the row glides left to close the gap.
  function slideCardOut(card) {
    var rail = card.parentNode;
    if (!rail) return;
    // fade/shrink the leaving card; its layout box stays put, so siblings don't move yet
    card.style.transition = 'opacity .16s ease, transform .16s ease';
    card.style.opacity = '0';
    card.style.transform = 'scale(.82)';
    card.style.pointerEvents = 'none';
    window.setTimeout(function () {
      var sibs = Array.prototype.filter.call(rail.children, function (c) {
        return c !== card && c.classList && c.classList.contains('fb-rec-card');
      });
      var firsts = sibs.map(function (c) { return c.getBoundingClientRect().left; }); // FIRST
      if (card.parentNode) card.parentNode.removeChild(card);                          // remove → reflow
      var lasts = sibs.map(function (c) { return c.getBoundingClientRect().left; });   // LAST
      sibs.forEach(function (c, i) {                                                   // INVERT
        var dx = firsts[i] - lasts[i];
        if (!dx) return;
        c.style.transition = 'none';
        c.style.transform = 'translateX(' + dx + 'px)';
      });
      window.requestAnimationFrame(function () {                                       // PLAY
        sibs.forEach(function (c, i) {
          if (firsts[i] - lasts[i] === 0) return;
          c.style.transition = 'transform .34s cubic-bezier(.22,.61,.36,1)';
          c.style.transform = 'translateX(0)';
        });
      });
      window.setTimeout(function () {
        sibs.forEach(function (c) { c.style.transition = ''; c.style.transform = ''; });
      }, 380);
    }, 150);
  }

  // A thumbnail clone that travels from `startRect` to an arbitrary `targetRect` (here: the
  // new line's photo slot inside the open drawer), morphing to the target size on the way.
  function flyToRect(startRect, imgSrc, targetRect, onArrive, onLiftoff) {
    var lift = onLiftoff || function () {};
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !startRect || !targetRect || !imgSrc || !startRect.width || !targetRect.width) { lift(); onArrive(); return; }
    var clone = document.createElement('img');
    clone.className = 'fb-cd-fly';
    clone.setAttribute('aria-hidden', 'true');
    clone.src = imgSrc;
    clone.style.left = startRect.left + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    document.body.appendChild(clone);
    var tx = (targetRect.left + targetRect.width / 2) - (startRect.left + startRect.width / 2);
    var ty = (targetRect.top + targetRect.height / 2) - (startRect.top + startRect.height / 2);
    var scx = targetRect.width / startRect.width, scy = targetRect.height / startRect.height;
    void clone.offsetWidth; // reflow so the transition runs from the start rect
    clone.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scx + ',' + scy + ')';
    clone.style.opacity = '0'; // CSS delays the fade to the last leg, so it stays full mid-flight
    lift(); // the photo is now visibly in flight — only now may the caller collapse the source
    var done = false;
    function finish() { if (done) return; done = true; if (clone.parentNode) clone.parentNode.removeChild(clone); onArrive(); }
    clone.addEventListener('transitionend', function (ev) { if (ev.propertyName === 'transform') finish(); });
    window.setTimeout(finish, 720); // fallback if transitionend never fires
  }
  function mediaRectOf(row) {
    var m = row.querySelector('.fb-cd-item__media');
    return (m || row).getBoundingClientRect();
  }
  // Controlled insert: the row is ALREADY collapsed (0 height, faded, nudged up); grow it to its
  // natural size, pushing the rest of the list down — instead of popping in. fullH/padding are
  // measured by the caller BEFORE collapsing (measuring here would read the collapsed 0).
  function expandRowIn(row, fullH, padT, padB) {
    void row.offsetWidth; // make sure the collapsed state is committed before we animate
    window.requestAnimationFrame(function () {
      row.style.transition = 'max-height .38s cubic-bezier(.22,.61,.36,1), padding-top .38s cubic-bezier(.22,.61,.36,1), padding-bottom .38s cubic-bezier(.22,.61,.36,1), opacity .32s ease, transform .38s cubic-bezier(.22,.61,.36,1)';
      row.style.maxHeight = fullH + 'px';
      row.style.paddingTop = padT;
      row.style.paddingBottom = padB;
      row.style.opacity = '1';
      row.style.transform = 'translateY(0)';
    });
    window.setTimeout(function () { // drop the inline overrides so the row is fully natural after
      row.style.transition = ''; row.style.maxHeight = ''; row.style.overflow = '';
      row.style.paddingTop = ''; row.style.paddingBottom = ''; row.style.transform = ''; row.style.opacity = '';
    }, 460);
  }
  // In-drawer rec add. ORDER MATTERS: the photo must take flight FIRST — straight from the
  // live card — and only once it's airborne do we collapse that card + slide the rail. If we
  // collapsed first, the rail would shift and the late-launching photo would appear to fly out
  // of whatever card slid into that spot (pork out of a chicken photo). So: fly immediately on
  // click (target = where the new top row will sit), collapse on liftoff, expand the row on land.
  function addRecToDrawer(card, vid, startRect, imgSrc) {
    var firstItem = itemsEl.querySelector('.fb-cd-item');
    var targetRect = firstItem ? mediaRectOf(firstItem) : itemsEl.getBoundingClientRect(); // provisional top slot

    var arrived = false, doExpand = null;
    function maybeExpand() { if (arrived && doExpand) { var fn = doExpand; doExpand = null; fn(); } }

    // 1) FLY FIRST — launched synchronously from the real card position.
    flyToRect(startRect, imgSrc, targetRect,
      function () { arrived = true; maybeExpand(); },                                   // onArrive → grow the row in
      function () { window.setTimeout(function () { slideCardOut(card); }, 120); });    // onLiftoff → collapse card + slide rail

    // 2) Server add runs in parallel; insert the new row collapsed; expand it when the photo lands.
    ownMuteUntil = Date.now() + 1500; // our own write — the fetch-wrap must not double-refresh
    window.fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin', body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(cartJSON)
      .then(function (line) { return getCart().then(function (cart) { return { line: line, cart: cart }; }); })
      .then(function (res) {
        var cart = res.cart, line = res.line;
        lastCart = cart; marcaServidor(cart);
        selfMutating = true;
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        selfMutating = false;
        var item = null;
        for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === line.key) { item = cart.items[i]; break; } }
        var existing = item ? rowFor(item.key) : null;
        if (existing) { // already in the cart (rare — rec cards dedupe): just bump qty
          var nEl = existing.querySelector('.fb-cd-qty__n'); if (nEl) nEl.textContent = item.quantity;
          setDecState(existing.querySelector('[data-cd-dec]'), item.quantity);
          var nowEl = existing.querySelector('.fb-cd-item__now'); if (nowEl) nowEl.textContent = money(item.final_line_price);
          paintTotals(cart);
          return;
        }
        if (!item) { render(cart); return; } // safety net
        var tmp = document.createElement('div');
        tmp.innerHTML = itemHTML(item);
        var row = tmp.firstElementChild;
        if (emptyEl) emptyEl.hidden = true;
        if (footEl) footEl.hidden = false;
        itemsEl.scrollTop = 0;                         // make sure the new top row is in view
        itemsEl.insertBefore(row, itemsEl.firstChild); // newest-first (render() reverses to match)
        var cs = window.getComputedStyle(row);
        var padT = cs.paddingTop, padB = cs.paddingBottom;
        var fullH = row.getBoundingClientRect().height; // natural height — measured BEFORE collapsing
        // collapse instantly so the list looks unchanged until the photo arrives
        row.style.overflow = 'hidden'; row.style.maxHeight = '0px';
        row.style.paddingTop = '0px'; row.style.paddingBottom = '0px';
        row.style.opacity = '0'; row.style.transform = 'translateY(-5px)'; row.style.transition = 'none';
        doExpand = function () { expandRowIn(row, fullH, padT, padB); paintTotals(cart); };
        maybeExpand(); // if the photo already landed, grow now; else onArrive will
      })
      .catch(function (err) { aviso(err); refresh(); });
  }

  function bindRecAdd(container, isEmptyRail) {
    if (!container) return;
    container.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-fb-rec-add]') : null;
      if (!btn) return;
      var card = btn.closest('.fb-rec-card');
      var vid = card && card.getAttribute('data-vid');
      if (!vid) return;
      btn.classList.add('is-loading');
      var img = card.querySelector('img');
      var startRect = img ? img.getBoundingClientRect() : null;
      var imgSrc = img ? (img.currentSrc || img.src) : null;

      if (!isEmptyRail) { addRecToDrawer(card, vid, startRect, imgSrc); return; }

      // Empty-cart rail: the add flips the whole drawer from empty → items, so keep it simple —
      // fly to the header cart and let the standard refresh build the items list.
      var addP = window.fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin', body: JSON.stringify({ id: vid, quantity: 1 })
      }).then(function (r) { return r.json(); });
      var collapsed = false;
      function onLiftoff() { if (collapsed) return; collapsed = true; slideCardOut(card); }
      if (window.fbFly) window.fbFly(img, addP.then(function () { return 1; }), startRect, onLiftoff);
      else onLiftoff();
      addP.then(function () { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); })
          .catch(function () { refresh(); });
    });
  }
  bindRecAdd(recsRail, false);
  bindRecAdd(emptyRecsEl, true);

  /* ---- stay in sync with external cart changes (add from cards/PDP, cart page, etc.) ---- */
  // Tras repintar desde el servidor se avisa con el carrito a bordo: la ficha (fb-product)
  // y la burbuja del header se sincronizan sin volver a pedir /cart.js. Nuestro propio
  // oyente lo ignora (selfMutating), así que no hay bucle.
  function refresh() {
    return getCart().then(function (cart) {
      marcaServidor(cart); // viene del servidor: es la fuente de claves vigentes
      render(cart);
      selfMutating = true;
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      selfMutating = false;
    }).catch(function () {});
  }
  // coalesce bursts into one re-render
  var refreshT = null;
  function scheduleRefresh(ms) {
    if (refreshT) window.clearTimeout(refreshT);
    refreshT = window.setTimeout(function () { refreshT = null; refresh(); }, ms || 90);
  }
  // selfMutating guard: skip our own optimistic-change dispatch (we already updated in place).
  // Si el evento trae el carrito (fb-commerce, fb-product, este mismo guion), se pinta de ahí
  // y no se vuelve a pedir /cart.js: cada alta disparaba hasta 8 lecturas entre todos los guiones.
  function onCartEvent(e) {
    if (selfMutating) return;
    var cart = e && e.detail && e.detail.cart;
    if (cart && cart.items) {
      if (refreshT) { window.clearTimeout(refreshT); refreshT = null; }
      marcaServidor(cart); // lo mandó otro guion tras hablar con el servidor
      render(cart);
    } else {
      scheduleRefresh();
    }
  }
  // Listen broadly — different add sources fire different events (Rebuy uses its own namespace).
  ['cart:updated', 'cart:refresh', 'rebuy:cart.change', 'rebuy:smartcart.ready'].forEach(function (ev) { document.addEventListener(ev, onCartEvent); });
  // Catch-all, mirroring the header bubble: refresh after ANY /cart mutation no matter which script
  // triggered it (events alone proved unreliable — that's why the peek sometimes didn't update). Our
  // OWN writes set ownMuteUntil so they don't trigger a disruptive full re-render — they already
  // update the drawer + peek optimistically in place. Espera 600 ms: si en ese lapso llega un
  // cart:updated con el carrito, onCartEvent cancela este refresco y no se lee dos veces.
  if (window.fetch) {
    var _origFetch = window.fetch;
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      var p = _origFetch.apply(this, arguments);
      try {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          p.then(function () { if (Date.now() >= ownMuteUntil) scheduleRefresh(600); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }
  // Para la barra fija de la ficha y cualquier otro guion que necesite abrir el cajón.
  window.fbCartDrawer = { open: openFull, close: close, isOpen: isOpen };
  refresh(); // initial paint so the drawer is ready before the first hover
})();
